import React, { FC } from 'react'

const KeyIcon: FC = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 6.5C18 10.0899 15.0899 13 11.5 13C10.9837 13 10.4815 12.9398 10 12.8261V15H7V18H2C0.89543 18 0 17.1046 0 16V12.8284C0 12.298 0.210714 11.7893 0.585786 11.4142L5.01763 6.98237C5.00594 6.82311 5 6.66225 5 6.5C5 2.91015 7.91015 0 11.5 0C15.0899 0 18 2.91015 18 6.5ZM13 6.25C13.6904 6.25 14.25 5.69036 14.25 5C14.25 4.30964 13.6904 3.75 13 3.75C12.3096 3.75 11.75 4.30964 11.75 5C11.75 5.69036 12.3096 6.25 13 6.25Z"
      fill="#FAFAFA"
    />
  </svg>
)

export default KeyIcon
